module.exports = __webpack_public_path__ + "img/csjz-active.2668fb7a.svg";